import { Dialog, Grid } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import Header from '../../lib/AppBar';
import useDialogAriaHidden from '../../hooks/useDialogAriaHidden';
import Footer from '../../lib/Footer';

import en from '../../lang/en-us';
import ResetDevices from './ResetDevices';
import { getPageHeading } from '../../lib/pageHeading';

const {
    login: { quickLinks, applyPan, form: LoginForm },
    signUp: { form: SignupForm },
} = en;

function QuickLinksCard({
    imgSrc,
    title,
    url = '#',
}: {
    imgSrc: string;
    title: string;
    url: string;
}) {
    return (
        <div className="quick-links-info">
            <a href={url}>
                <img src={imgSrc} alt="" aria-hidden="true" />
                <p>{title}</p>
            </a>
        </div>
    );
}

const links = [
    { imgSrc: '/images/update-pan.svg', url: '#', title: quickLinks.pan.title },
    { imgSrc: '/images/transmission-login.svg', url: '#', title: quickLinks.transmission.title },
];
export default function Wrapper({ children, ...props }: any) {
    const [show, setShow] = useState<boolean>(false);
    const applyPanHeadingRef = useRef<HTMLHeadingElement>(null);

    useEffect(() => {
        if (show) {
            applyPanHeadingRef.current?.focus();
        }
    }, [show]);

    useDialogAriaHidden(show);

    const setDataByPath = (): any => {
        const { pathname = '' } = props.location;
        const { path: BASE_PATH = '' } = props.match;
        switch (pathname) {
            case `${BASE_PATH}/signin`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            case `${BASE_PATH}/forgot-password`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            case `${BASE_PATH}/forgot-password-otp`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            case `${BASE_PATH}/forgot-password-questionnaire`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            case `${BASE_PATH}/reset-password`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            case `${BASE_PATH}/signup`:
                return { img: 'signup-img.png', extraClass: 'signup-left', ...SignupForm };
            case `${BASE_PATH}/signup-otp`:
                return { img: 'signup-img.png', extraClass: 'signup-left', ...SignupForm };
            case `${BASE_PATH}/set-password`:
                return { img: 'signup-img.png', extraClass: 'signup-left', ...SignupForm };
            case `${BASE_PATH}/signin-questionnaire`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            case `${BASE_PATH}/reset-question-otp`:
                return { img: 'signin-img.png', extraClass: 'signin-left', ...LoginForm };
            default:
                return { img: 'signin-img.png', extraClass: 'signin-left' };
        }
    };

    const {
        img,
        title1 = '',
        secondaryTitle = '',
        titleCaption = '',
        extraClass,
    } = setDataByPath();

    const mainAriaLabel = getPageHeading(props?.location?.pathname || '') || 'Sign In';

    return (
        <>
            <Header {...props} />
            <main id="main-content" className="container-fluid" aria-label={mainAriaLabel}>
                <div className="login-content-outer">
                    <div className="maxWidth login-container">
                        <div className="login-content">
                            <div className="login-content-inner">
                                <div className={`login-content-left ${extraClass}`}>
                                    <h1>
                                        {title1} <span>{secondaryTitle}</span>
                                    </h1>
                                    <h2>{titleCaption}</h2>
                                    <img src={`/images/${img}`} alt="" aria-hidden="true" />
                                </div>

                                <div className="login-content-right">{children}</div>
                            </div>
                        </div>
                        <div className="quick-links">
                            <div className="quick-links-text">
                                <h3
                                    style={{
                                        fontSize: '24px',
                                        fontWeight: 900,
                                        margin: '0 0 8px 0',
                                        color: '#333',
                                        fontFamily: 'Montserrat-ExtraBold',
                                        lineHeight: '29px',
                                    }}
                                >
                                    <span style={{ color: '#333' }}>{quickLinks.title}</span>{' '}
                                    <span style={{ color: '#4A148C' }}>
                                        {quickLinks.secondaryTitle}
                                    </span>
                                </h3>
                                <p>{quickLinks.easyAccess}</p>
                            </div>
                            <ul className="quick-links-cards" role="list" aria-label="Quick Links">
                                <li role="listitem" className="quick-links-info">
                                    <a
                                        href="/links/purchase"
                                        role="link"
                                        tabIndex={0}
                                        aria-label="Explore Mutual Funds"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            props.history.push('/links/purchase');
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                props.history.push('/links/purchase');
                                            }
                                        }}
                                    >
                                        <img src="/images/explore-mf.svg" alt="" aria-hidden="true" />
                                        <p>{quickLinks.explore.title}</p>
                                    </a>
                                </li>
                                <li role="listitem" className="quick-links-info">
                                    <a
                                        href="/links"
                                        role="link"
                                        tabIndex={0}
                                        aria-label="Update PAN Details"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            props.history.push('/links');
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                props.history.push('/links');
                                            }
                                        }}
                                    >
                                        <img src="/images/update-pan.svg" alt="" aria-hidden="true" />
                                        <p>{quickLinks.pan.title}</p>
                                    </a>
                                </li>
                                <li role="listitem" className="quick-links-info">
                                    <button
                                        type="button"
                                        className="quick-links-trigger"
                                        tabIndex={0}
                                        aria-label="Apply for PAN"
                                        onClick={() => setShow(!show)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                setShow(!show);
                                            }
                                        }}
                                    >
                                        <img src="/images/apply-pan.svg" alt="" aria-hidden="true" />
                                        <p>{quickLinks.applyPan.title}</p>
                                    </button>
                                </li>
                                <li role="listitem" className="quick-links-info">
                                    <a
                                        href="/links/transmission-request"
                                        role="link"
                                        tabIndex={0}
                                        aria-label="Transmission Request"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            props.history.push('/links/transmission-request');
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                props.history.push('/links/transmission-request');
                                            }
                                        }}
                                    >
                                        <img
                                            src="/images/transmission-login.svg"
                                            // src="/images/transmission-login-comingsoon.svg"
                                            alt=""
                                            aria-hidden="true"
                                        />
                                        <p>{quickLinks.transmission.title}</p>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
            <Dialog
                fullWidth
                maxWidth={'md'}
                open={show}
                role="dialog"
                aria-modal="true"
                aria-labelledby="applyPanModal"
            >
                <div className="applyPanModal">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4
                                    id="applyPanModal"
                                    ref={applyPanHeadingRef}
                                    tabIndex={-1}
                                    className="modal-title"
                                >
                                    {applyPan.heading}
                                </h4>
                                <button
                                    type="button"
                                    aria-label="Close modal"
                                    onClick={() => setShow(!show)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            setShow(!show);
                                        }
                                    }}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        padding: 0,
                                        cursor: 'pointer',
                                    }}
                                >
                                    <img src="/images/close-black.svg" alt="" aria-hidden="true" />
                                </button>
                            </div>
                            <div className="modal-body">
                                <h6>{applyPan.info}</h6>
                                <h6>{applyPan.infoBottom}</h6>
                                <div className="pan-links">
                                    <img
                                        src="/images/attachment.svg"
                                        alt=""
                                        aria-hidden="true"
                                        className="pan-attachment-img"
                                    />
                                    <div className="pan-website-img">
                                        <img src="/images/nsdl.png" alt="" aria-hidden="true" />
                                    </div>
                                    <p>NSDL</p>
                                    <a
                                        href="https://www.onlineservices.nsdl.com/paam/endUserRegisterContact.html"
                                        target="_blank"
                                    >
                                        {applyPan.clickHere}
                                    </a>
                                </div>
                                <div className="pan-links">
                                    <img
                                        src="/images/attachment2.svg"
                                        alt=""
                                        aria-hidden="true"
                                        className="pan-attachment-img"
                                    />
                                    <div className="pan-website-img">
                                        <img src="/images/utiitsl.png" alt="" aria-hidden="true" />
                                    </div>
                                    <p>UTIITSL</p>
                                    <a
                                        href="https://www.pan.utiitsl.com/PAN/mainform.html"
                                        target="_blank"
                                    >
                                        {applyPan.clickHere}
                                    </a>
                                </div>
                                <div className="pan-info">
                                    <p>
                                        {applyPan.websiteInfo}{' '}
                                        <a
                                            href="https://www.incometaxindia.gov.in/Pages/tax-services/apply-for-pan.aspx"
                                            target="_blank"
                                        >
                                            https://www.incometaxindia.gov.in/Pages/tax-services/apply-for-pan.aspx
                                        </a>{' '}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
